import React from 'react';
import ClientsCases from './../components/ClientsCases/'

class Work extends React.Component {

  render() {
    return (
      <React.Fragment>
        <div className="row work">
          <div className="col-md-6 col-12 container__high work__content">
          <h1>Work</h1>
            <p>Spécialistes de la communication commerciale, notre mission est de générer la
            préférence pour les marques de nos clients, en respectant les objectifs de leur contrat
            marchand, et en créant des liens émotionnels et durables avec leurs clients.</p>
          </div>
          <div className="col-md-6 col-12 bg--black no-padding center-text">
            <img src="/images/hashtags.gif" alt="Hashtags" />
          </div>
        </div>
        <ClientsCases origin="work" />

      </React.Fragment>
    )
  }
}

export default Work




// WEBPACK FOOTER //
// ./src/containers/Work.jsx